import { API } from "../../api";
import { objectToQueryString } from "../../../helpers/objectToQueryString";
async function all_branches(request) {
    // console.log("all_branches -> request", request);
    const clientId = process.env.LETS_TRADE_CLIENT_ID;
    return await new API().apiGet({
        baseUrl: process.env.LETS_TRADE_CLIENT_URL ?? "",
        endpoint: `v2/client/branches${objectToQueryString({
            client_id: clientId,
        })}`,
    });
}
export { 
// IAllBranchesRequest,
all_branches, };
